import { Expose } from 'class-transformer';

import { ExposeRawData } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnLpr extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public name: string;

  @Expose()
  public hotlistName: string;

  @Expose()
  public deduplicationSources: string[];

  @Expose()
  public defaultExpirationDuration: string;

  @Expose()
  public isPublic: boolean;

  @Expose()
  public type: string;

  @Expose()
  public dolpPolicies: string;

  @Expose()
  public dolpUsers: any;

  @ExposeRawData()
  public properties: any;

  @Expose()
  public isDefaultHotlist: boolean;

  @Expose()
  public provider: string;

  @Expose()
  public filterAlerts: boolean;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
